module.exports = __webpack_public_path__ + "static/img/nongye.55bf5b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/data_cate_icon/nongye.png
// module id = J0Re
// module chunks = 5